<div class="tt-medication-edit-dialog_header">
  <h2 class="tt-medication-edit-dialog_header-title">{{ data.title }}</h2>
  <button aria-label="Close dialog"
    class="tt-medication-edit-dialog_close-button"
    emphasis="minimal"
    size="small"
    ttButton
    variant="transparent"
    (click)="dialogRef.close()">
    <mat-icon [icon]="'x'" [iconSize]="22" />
  </button>
</div>

<div class="tt-medication-edit-dialog_content">
  <tt-form-field>
    <label for="name" ttLabel>{{ 'Sidebar.EditDialog.Name' | transloco }}</label>
    <input id="name" required ttInput [ngModelOptions]="{ standalone: true }" [(ngModel)]="title" />
  </tt-form-field>

  <tt-form-field class="tt-medication-edit-dialog_content-description">
    <label for="description" ttLabel>{{ 'Description' | transloco }}</label>

    <div class="tt-medication-edit-dialog_content-description-wrapper">
      <common-rich-text-editor [toolbarType]="'reduced'" [(editorContent)]="description" />
    </div>
  </tt-form-field>
</div>

<div class="tt-medication-edit-dialog_actions">
  <button class="tt-medication-edit-dialog_actions-cancel" ttButton variant="secondary" (click)="dialogRef.close()">
    <span>{{ 'Cancel' | transloco }}</span>
  </button>
  <button class="tt-medication-edit-dialog_actions-save" ttButton [disabled]="!title()" (click)="saveEditedData()">
    <span>{{ 'Confirm' | transloco }}</span>
  </button>
</div>
